/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Supported frequencies of payment.   (german: Zahlweise)   (bipro-datentypen::Zahlungsweise)
 */
export const PaymentFrequency = {
  Yearly: 'Yearly',
  HalfYearly: 'HalfYearly',
  Quarterly: 'Quarterly',
  Monthly: 'Monthly',
} as const;
export type PaymentFrequency = (typeof PaymentFrequency)[keyof typeof PaymentFrequency];
